import { useEffect, useState } from 'react';

export const useHelpCrunchIsReady = () => {
  const [ready, setReady] = useState<boolean>(false);
  useEffect(() => {
    // @ts-ignore
    if (!window.HelpCrunch) {
      return;
    }
    // @ts-ignore
    window.HelpCrunch('onReady', () => {
      setReady(true);
    });
    // @ts-ignore
  }, [window.HelpCrunch]);
  return ready;
};
